export const SPARE_DOMAIN_LIST = 'SPARE_DOMAIN_LIST';
export const SPARE_DOMAIN_CREATE = 'SPARE_DOMAIN_CREATE';
export const SPARE_DOMAIN_DELETE = 'SPARE_DOMAIN_DELETE';